// extracted by mini-css-extract-plugin
export var root = "DeviceBlock-module--root--3xrw4";
export var imageOnLeft = "DeviceBlock-module--image-on-left--33hWw";
export var title = "DeviceBlock-module--title--2K6NB";
export var subtitle = "DeviceBlock-module--subtitle--ZZLEr";
export var content = "DeviceBlock-module--content--2PSEZ";
export var listItems = "DeviceBlock-module--list-items--2GqRt";
export var listItem = "DeviceBlock-module--list-item--3LTAY";
export var listItemContent = "DeviceBlock-module--list-item-content--2Me15";
export var dppDeviceBlock = "DeviceBlock-module--dpp-device-block--2AdYZ";